import React from "react";
import { Button } from "@/components/Buttons";
import { BackIcon } from "@/icons/BackIcon";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface BackButtonProps {     
    onClick?: () => void;
    className?: string;
}

export const BackButton = ({onClick, className}: BackButtonProps) => {
    const navigate = useNavigate();
    const { t } = useTranslation('BackButton');
    return (
        <Button text={t('back')} 
        onClick={onClick ? onClick : () => {navigate(-1)}} 
        icon="left-side" 
        iconComponent={BackIcon} 
        id="back-button" 
        ready={true} 
        color="gray" 
        className={className}/>
    );
}